// extracted by mini-css-extract-plugin
export default {"switchTrack":"switch_switchTrack__Yn+kY","checked":"switch_checked__dogMk","switchThumb":"switch_switchThumb__r-VNl"};